<template>
    <settings-editor-base>
        <template v-slot="{inputId}">
            <div class="row">
                <div class="col-4">
                    <input
                            ref="input"
                            v-bind:id="inputId"
                            v-bind:value="value"
                            v-model="model"
                            type="checkbox" />
                </div>

                <div class="col-8">
                    <label v-bind:for="inputId">{{text}}</label>
                </div>
            </div>
        </template>
    </settings-editor-base>
</template>

<script>
    import $ from 'jquery';
    import SettingsEditorBase from "./SettingsEditorBase.vue";

    export default {
        name: "settings-checkbox",
        components: {SettingsEditorBase},
        mounted() {
            $(this.$refs.input).prop('checked', this.value);
        },
        computed: {
            model: {
                get(){
                    return this.value;
                },
                set(value){
                    this.$emit('input', value);
                }
            }
        },
        props: {
            text: {
                type: String,
                required: true
            },
            value: undefined
        }
    };
</script>
